import firebase from '@utils/firebase';
import {
  INIT_AUTH_REQUEST,
  INIT_AUTH,
  LOGIN_REQUEST,
  LOGIN_WITH_EMAIL,
  LOGOUT_REQUEST,
  LOGOUT,
} from '.';
import { openSnackbarMessage } from './appsActions';

const initAuthRequest = () => ({ type: INIT_AUTH_REQUEST });
const initAuthSuccess = (user, idToken) => ({ type: INIT_AUTH, user, idToken });
const loginRequest = (type) => ({ type });
const loginSuccess = (type, result) => ({ type, result });
const loginFailure = (type, error) => ({ type, error });
const logoutRequest = () => ({ type: LOGOUT_REQUEST });
const logoutSuccess = () => ({ type: LOGOUT });
const logoutFailure = (error) => ({ type: LOGOUT, error });

export const initAuth = () => (dispatch) => {
  const url = new URL(window.location.href);
  if (url.searchParams.has('uid')) {
    url.searchParams.delete('uid');
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
  }
  dispatch(initAuthRequest());
  firebase.auth().onAuthStateChanged((user) => {
    if (!user) {
      dispatch(initAuthSuccess(user, null));
    } else {
      user
        .getIdToken(false)
        .then((idToken) => {
          dispatch(initAuthSuccess(user, idToken));
        })
        .catch((error) => {
          window.console.error(error);
        });
    }
  });
};

// For Email

export const loginWithEmail = (email, password) => async (dispatch) => {
  dispatch(loginRequest(LOGIN_REQUEST));
  function delay(n) {
    return new Promise(function (resolve) {
      setTimeout(resolve, n * 1000);
    });
  }
  await delay(3);
  firebase
    .auth()
    .signInWithEmailAndPassword(email, password)
    .then((result) => {
      dispatch(loginSuccess(LOGIN_WITH_EMAIL, result));
      dispatch(initAuth());
    })
    .catch((error) => {
      dispatch(loginFailure(LOGIN_WITH_EMAIL, error));
      switch (error.code) {
        case 'auth/invalid-email':
          dispatch(openSnackbarMessage('error', 'Email address format is incorrect.'));
          break;
        case 'auth/user-not-found':
          dispatch(openSnackbarMessage('error', 'Email address is not registered.'));
          break;
        case 'auth/wrong-password':
          dispatch(openSnackbarMessage('error', 'Invalid password.'));
          break;
        default:
          loginWithEmail(email, password);
          dispatch(openSnackbarMessage('error', `${error.message} [${error.code}]`));
      }
    });
};

export const logout = () => (dispatch) => {
  dispatch(logoutRequest());
  firebase
    .auth()
    .signOut()
    .then(() => dispatch(logoutSuccess()))
    .catch((error) => {
      window.console.error(error);
      dispatch(logoutFailure(error));
    });
};
